export function routineEditFromRoutine(routine = {}) {
  return {
    roomNumber: routine.roomNumber || "N/A",
    subjectId: routine.subjectId || "",
    subjectName: routine.subjectName || "",
    teacherId: routine.teacherId || "",
    teacherName: routine.teacherName || "",
    scheduledIn: routine.scheduledIn || "",
    scheduledOut: routine.scheduledOut || ""
  };
}

export function routineEditPatch(routine = {}, edit = {}) {
  const patch = {};
  ["roomNumber", "subjectId", "subjectName", "teacherId", "teacherName", "scheduledIn", "scheduledOut"].forEach((key) => {
    const nextValue = String(edit[key] || "").trim();
    if (nextValue && nextValue !== String(routine[key] || "")) {
      patch[key] = nextValue;
    }
  });
  return patch;
}

export function hasRoutineEditPatch(patch = {}) {
  return Object.keys(patch).length > 0;
}

export function applyRoutineEdit(routine = {}, edit = {}) {
  return {
    ...routine,
    ...routineEditPatch(routine, edit)
  };
}
